import { Helmet } from 'react-helmet-async';

export default function HelmetMeta({title}) {
    return (
        <Helmet>
            <title>{`${title} | BuildX POS`}</title>
        </Helmet>
    );
}
